<template>
    <div class="mb-6 py-1 pb-md-6 d-flex align-center flex-column">
        <template v-if="stepActive != 7 || !editPlan">
            <!-- <p>Proceed to <strong>Step {{ stepActive }}</strong> of 6</p> -->
            <p class="mt-2">or
                <span class="save-for-late" @click="clearData" @mouseenter="showButton = true" @mouseleave="showButton = false">Start Over
                <v-tooltip
                    v-if="showButton" 
                    v-model="show"
                    close-delay="800" 
                    activator="parent"
                    location="end"                
                >Сleared</v-tooltip>
                </span>
            </p>
        </template>
        <template v-if="stepActive == 7">
            <p class="footer-description">Proceed to pay and we will add this plan to your basket to checkout</p>
        </template>
    </div>
</template>

<script>
import Cookies from 'js-cookie';

export default {
    name: 'footerApp',
    data() {
        return {
            show: false,
            showButton: false,
            editPlan: false
        };
    },
    computed: {
        currentUserID() {
            return this.$store.getters.currentUserID;
        },
        itemsOrder() {
            return this.$store.getters.itemsOrder;
        },
        wizardMenu() {
            return this.$store.getters.wizardMenu;
        },
        stepActive() {
            let i;

            this.wizardMenu.forEach((item, index) => {                
               
                if (item.isActive === true) {
                    i = index;                    
                }
                
            });

            return i;
        },
        allergies() {
            return this.$store.getters.getAllergies;
        },
        weeklyPlan() {
            return this.$store.getters.weeklyPlan;
        },
        orderProducts() {
            return this.$store.getters.orderProducts;
        },
        menus() {
            return this.$store.getters.getMenus;
        },
        currentUserData() {
            return this.$store.getters.currentUserData;
        }
    },
    methods: {
        clearData() {         

            this.showButton = true;
            this.show = true;

            Cookies.remove('plan');            
            Cookies.remove('allergies');
            Cookies.remove('allergiesNo');
            Cookies.remove('protein'); 
            Cookies.remove('days');
            Cookies.remove('breakfastCount');
            Cookies.remove('mainCount');
            Cookies.remove('snacksCount');

            setTimeout(() => {
                
                this.showButton = false;
                this.show = false;

                // this.wizardMenu.forEach((item, index) => {

                //     item.view = false;
                //     item.isActive = false;

                //     if (index == 0) {
                //         item.isActive = true;
                //     }
                // });
                
                window.location.href = '/order/';

            }, 2000);
        }
    },
    async beforeMount() {
        const urlCurrent = new URL(window.location.href);
        const params = new URLSearchParams(urlCurrent.search);
        this.orderID = params.get('order');

        if (this.orderID) {
            this.editPlan = true;
        }
    }
}
</script>

<style scoped  lang="stylus">
    .save-for-late {
        font-family: 'Manrope', sans-serif;
        font-weight: 700;
        font-size: 16px;
        line-height: 22px;
        color: #685BC7;
        position: relative;
        cursor: pointer;

        &:after {
            position: absolute;
            content: '';
            bottom: 0;
            left: 0;
            transition-duration: .4s;
            width: 100%;
            height: 1px;
            background: #685BC7;
        }

        &:hover {
            &:after {
                width: 0;
            }
        }

        &.disabled {
            opacity: 0.7;
            cursor: no-drop;

            &:hover {
                &:after {
                    width: 100%;
                }
            }
        }
    }
    
    footer {
        p.footer-description {
            font-size: 16px;
            max-width: 300px;
            text-align: center;

            @media screen and (max-width: 767px) {
                font-size: 14px;
            }
        }
    }
</style>